var map = {
	"./bootstrap/choices.tpl.html": 446,
	"./select2/choices.tpl.html": 447,
	"./selectize/choices.tpl.html": 448
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 445;


//////////////////
// WEBPACK FOOTER
// ./src/app/third/ui-select/src ^\.\/.*\/choices\.tpl\.html$
// module id = 445
// module chunks = 0